import React, { useState } from "react";
import { FaBars, FaTimes, FaGithub, FaLinkedin, FaBehance } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { Link } from "react-router-dom";


export default function Navbar() {
  const [nav, setNav] = useState(false);
  const handleClick = () => {
    setNav(!nav);
  };

  return (
    <div
      className=" z-50 fixed top-0 w-full h-[90px] justify-end items-center text-white
    font-bold inset-x-0 flex-col text-xl sm:flex sm:flex-row bg-text border-b border-text"
    >
      {/* menu */}

      <ul className="hidden md:flex">
        <li className="px-4">
          <Link to="/" exact="true" className="hover:text-white/70 duration-300">
            Home
          </Link>
        </li>
        <li className="px-4">
          <Link to="/#about" className="hover:text-white/70 duration-300">
            About
          </Link>
        </li>
        <li className="px-4">
          <Link to="/skills" exact="true" className="hover:text-white/70 duration-300">
            Skills
          </Link>
        </li>
        <li className="px-4">
          <Link to="/work" className="hover:text-white/70 duration-300">
            Work
          </Link>
        </li>
        <li className="px-4">
          <Link to="/#contact" className="hover:text-white/70 duration-300">
            Contact
          </Link>
        </li>
      </ul>

      {/* Hamburger menu */}
      <div onClick={handleClick} className="md:hidden fixed w-12 top-0 right-0 py-8 text-white px-6 cursor-pointer">
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile menu */}
      {nav && (
        <ul className="md:hidden fixed inset-x-0 top-[90px] h-[calc(100vh-90px)] flex flex-col justify-center items-center text-white bg-primary-dark">
          <li className="py-6 text-4xl">
            <Link to="/" onClick={handleClick}>
              Home
            </Link>
          </li>
          <li className="py-6 text-4xl">
            <Link to="/#about" onClick={handleClick}>
              About
            </Link>
          </li>
          <li className="py-6 text-4xl">
            <Link to="/skills" onClick={handleClick}>
              Skills
            </Link>
          </li>
          <li className="py-6 text-4xl">
            <Link to="/work" onClick={handleClick}>
              Work
            </Link>
          </li>
          <li className="py-6 text-4xl">
            <Link to="/#contact" onClick={handleClick}>
              Contact
            </Link>
          </li>
          <li className="flex gap-8 pt-8 text-2xl">
            <a
              aria-label="LinkedIn"
              href="https://www.linkedin.com/in/agostinaboris/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClick}
              className="hover:text-white/70 duration-300"
            >
              <FaLinkedin size={28} />
            </a>
            <a
              aria-label="GitHub"
              href="https://github.com/AgostinaBoris"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClick}
              className="hover:text-white/70 duration-300"
            >
              <FaGithub size={28} />
            </a>
            <a
              aria-label="Email"
              href="mailto:borisagostina@gmail.com"
              onClick={handleClick}
              className="hover:text-white/70 duration-300"
            >
              <HiOutlineMail size={28} />
            </a>
            <a
              aria-label="Behance"
              href="https://www.behance.net/borisagostina"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClick}
              className="hover:text-white/70 duration-300"
            >
              <FaBehance size={28} />
            </a>
          </li>
        </ul>
      )}
    </div>
  );
}
